import { createCrudSlice, createCrudSliceSelectors } from '@/store/util';

import {
  indexAccountInvitations,
  newAccountInvitation,
  createAccountInvitation,
  destroyAccountInvitation,
} from './actions';

const options = {
  name: 'accountInvitations',
  collectionName: 'account_invitations',
  recordName: 'account_invitation',
  actionsConfig: {
    index: {
      read: indexAccountInvitations,
    },
    create: {
      read: newAccountInvitation,
      write: createAccountInvitation,
    },
    destroy: {
      write: destroyAccountInvitation,
    },
  },
};

export const {
  index: selectAccountInvitations,
  create: selectAccountInvitationForCreate,
  destroy: selectAccountInvitationForDestroy,
} = createCrudSliceSelectors(options);

const { reducer } = createCrudSlice(options);
export default reducer;
